import styled from 'styled-components'
import * as theme from '../theme'

export const BoxContainer = styled.div`
   background: ${theme.color.white};
   box-shadow: ${theme.shadow.base};
   border-radius: ${theme.border.radius};
   padding: ${theme.spacing.ml} ${theme.spacing.m};

   @media screen and (min-width: ${theme.breakpoint.s}) {
      padding: ${theme.spacing.xl} ${theme.spacing.xxl};
   }
`

export const BoxContainerLighter = styled(BoxContainer)`
   padding: ${theme.spacing.m} ${theme.spacing.m};

   @media screen and (min-width: ${theme.breakpoint.s}) {
      padding: ${theme.spacing.ml} ${theme.spacing.ml};
   }
`
